import React from 'react'
import { withRouter } from 'react-router-dom';
import {Card, CardHeader, CardBody,Box,Button,Heading, Text,Layer, } from 'grommet';
import {Close, User,Phone,MailOption,Globe,Notes,Launch, Organization, Schedule, Clock, Alert } from 'grommet-icons';
import Flag from 'react-world-flags'
import {ReturnRowDir} from './utils/shared/shared'
import moment from 'moment'



function returnLocation(location, label){
    return (
        <Card width='medium' pad="medium" round gap="small" elevation='medium' background='background-front'>
            <CardHeader >
                <Globe color='brand'/><Text weight='bold' size="medium">{label}</Text><Flag style={{margin: 5}}height='25' code={location.country.CountryCode} fallback={ <Text size='xsmall'>Unknown</Text> }/>
            </CardHeader>
            <CardBody gap='xsmall' overflow='scroll'>
                <Text size="xsmall" weight='bold'><Organization size='small' style={{marginRight:5}}/>{location.contact.companyName}</Text>
                <Text size="xsmall">{location.address_line_one},</Text>
                <Text size="xsmall">{location.address_line_two}, {location.address_line_three}</Text>
                <Text size="xsmall">{location.city},{(location.county ? `${location.county},` : null)} {location.postcode}</Text>
                <Text size="xsmall">{location.country.CountryName}</Text>
            
                <Text size="xsmall"><User size='small'/> {location.contact.contactName}</Text>
                <Text size="xsmall"><MailOption size='small'/> {location.contact.contactEmail}</Text>
                <Text size="xsmall"><Phone size='small'/> {location.contact.contactPhone}</Text>
            </CardBody>
        </Card>
    )
}


function returnCollection(shipment, pickupDetails){
    return (
        <Card pad="medium" round gap="small" elevation='large' background='background-front'>
            <CardHeader>
                <Schedule color='brand'/><Text size="medium" weight='bold'>Collection</Text><Clock color='brand'/>
            </CardHeader>
            <CardBody gap='xsmall' overflow='scroll'>
                <Text size='xsmall'>Pickup Location: {pickupDetails.pickupLocation}</Text>
                <Text size='xsmall'>Pickup Date: {moment(pickupDetails.pickupDate).format("DD/MM/YYYY")}</Text>
                <Text size='xsmall'>Pickup From Time: {pickupDetails.pickupEarlyTime}</Text>
                <Text size='xsmall'>Pickup Close Time: {pickupDetails.pickupCloseTime}</Text>
            </CardBody>
        </Card>
    )
}




function ConfirmCollection(props) {
    const shipment = props.shipment.shipments[0]
    const showLayer = props.showLayer
  return (
      <Box margin='small'>
        {/* Collection Details/Time  */}
        {showLayer && (
          <Layer animation="fadeIn" background={'background-back'} pad={'small'} >
            <CardHeader direction='row' margin='small'>
                <Button hoverIndicator icon={<Close color='status-critical'/>} onClick={() => props.setConfirmingShipment(false)}/><Heading level={4} size="small">Shipment Summary</Heading><Notes />
            </CardHeader>
            <CardBody margin='small' overflow='scroll'>
                <Box direction={ReturnRowDir(props.size)} gap='small' margin='small'>
                {returnLocation(shipment.origin, "Origin")}
                {returnCollection(shipment, props.shipmentPickup)}
                {returnLocation(shipment.destination, "Destination")}
                {/* {returnCommodity(props.value, shipmentSummaryData)} */}
                </Box>
            </CardBody>
             <Box elevation='medium' round margin={'small'} justify='center' background={'background-front'}>
             <Box justify='center'><Text size='small' weight='bold' alignSelf='center' margin='small' level={5} >Would you like to proceed with booking a collection for this shipment?</Text></Box>
             <Box justify='center' direction='row'><Alert color='status-critical'/><Text size='xsmall' margin={{left:'xsmall', top:'xsmall'}}>Please ensure the shipper has the correct paperwork and packages are ready for collection. Failed collection attempts may be charged.</Text></Box>
             <Box direction='row' margin={'small'} justify='center' gap='small'>
             <Button alignSelf='center' primary color='status-critical' label="Cancel" icon={<Close />} onClick={() => props.setConfirmingShipment(false)} />
                <Button alignSelf='center' primary color='status-ok' label="Yes" icon={<Launch />} type='submit' onClick={() => props.handleSubmit()} />
             </Box>
             </Box>
          </Layer>
        )}
    </Box>
  )
}

export default withRouter(ConfirmCollection)
